import { useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import posthog from "posthog-js";
import { useAccountingStore } from "../../../store/Accounting";
import { RemindersDueTab } from "./components/reminders-due-tab.component";
import { RemindersHistoryTab } from "./components/reminders-history-tab.component";
import {
	MahnwesenNavigationState,
	MahnwesenView,
} from "./payment-reminder.types";
import { parseMahnwesenView } from "./utils/mahnwesen-route";

export const MahnwesenPage: React.FC = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const location = useLocation();
	const view = parseMahnwesenView(searchParams.get("view"));
	const highlightedReminderIds =
		(location.state as MahnwesenNavigationState | null)
			?.createdReminderIds ?? [];

	useEffect(() => {
		posthog.capture("mahnwesen_page_viewed");
		useAccountingStore.getState().fetchRecipients();
	}, []);

	const handleViewChange = (nextView: MahnwesenView) =>
		setSearchParams({ view: nextView }, { replace: true });

	return (
		<div className="flex w-full flex-col items-center py-6">
			<div className="w-full max-w-[1920px] px-6">
				{view === "history" ? (
					<RemindersHistoryTab
						onViewChange={handleViewChange}
						highlightedReminderIds={highlightedReminderIds}
					/>
				) : (
					<RemindersDueTab
						key={view}
						mode={view}
						onViewChange={handleViewChange}
					/>
				)}
			</div>
		</div>
	);
};
